/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ispreselected2Inputs */

const en_entity_ispreselected2 = /** @type {(inputs: Entity_Ispreselected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Pre-Selected`)
};

const de_entity_ispreselected2 = /** @type {(inputs: Entity_Ispreselected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist vorausgewählt`)
};

/**
* | output |
* | --- |
* | "Is Pre-Selected" |
*
* @param {Entity_Ispreselected2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ispreselected2 = /** @type {((inputs?: Entity_Ispreselected2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ispreselected2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ispreselected2(inputs)
	return de_entity_ispreselected2(inputs)
});
export { entity_ispreselected2 as "entity_isPreSelected" }